// import React, { useState } from "react";
// import "./ConsentForm.css";

// const ConsentForm = () => {
//   const [consentGiven, setConsentGiven] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!consentGiven) {
//       alert("Please check the box to provide your consent.");
//       return;
//     }
//     alert("Thank you! Your consent has been recorded.");
//     console.log("Consent Given:", consentGiven);
//   };

//   return (
//     <div className="consent-container">
//       <h1>Consent Form for Personal Data</h1>
//       <form onSubmit={handleSubmit} className="consent-form">
       

//         <h2>Consent Statement</h2>
//         <label className="checkbox-label">
//           <input
//             type="checkbox"
//             checked={consentGiven}
//             onChange={() => setConsentGiven(!consentGiven)}
//           />
//           I consent to the collection, use, and disclosure of my personal
//           information as described above.
//         </label>

//         <button type="submit" className="submit-btn">
//           Submit Consent
//         </button>
//       </form>
//     </div>
//   );
// };

// export default ConsentForm;

import React, { useState } from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./ConsentForm.css";

const ConsentForm = () => {
  const [consentGiven, setConsentGiven] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!consentGiven) {
      Modal.warning({
        title: "Consent Required",
        content: "You must provide consent before proceeding.",
      });
      return;
    }

    localStorage.setItem("userConsent", JSON.stringify({ consent: true, date: new Date() }));
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
    const redirectPath = localStorage.getItem("redirectAfterConsent") || "/";
    navigate(redirectPath);
  };

  return (
    <div className="consent-container">
      <h1>Consent Form for Personal Data</h1>
      <form onSubmit={handleSubmit} className="consent-form">
        <div>
           <div className="info-section">
          <h2>Purpose of This Consent</h2>
          <p>
            We value your privacy. This form explains how we collect, use, and
            share your personal information in compliance with Canadian privacy
            laws, including the <strong>PIPEDA</strong>.
          </p>

          <h2>What Information We Collect</h2>
          <ul>
            <li>Name, address, phone number, and email address</li>
            <li>Identification details (such as date of birth)</li>
            <li>Financial information (for billing or payment)</li>
            <li>Other information you provide</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <ol>
            <li>Providing requested products or services</li>
            <li>Communicating with you</li>
            <li>Processing payments</li>
            <li>Improving services</li>
            <li>Meeting legal requirements</li>
          </ol>

          <h2>Disclosure</h2>
          <p>
            We may share your personal information with service providers,
            government authorities (if required by law), or with your consent.
            We do <strong>not</strong> sell your information.
          </p>

          <h2>Your Rights</h2>
          <p>
            You may access, correct, or withdraw your consent at any time.
            Complaints can be filed with the Office of the Privacy Commissioner
            of Canada.
          </p>

          <h2>Retention</h2>
          <p>
            Your data will only be kept as long as necessary for the stated
            purposes or as required by law.
          </p>
        </div>
          <h2>Consent Statement</h2>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={consentGiven}
              onChange={() => setConsentGiven(!consentGiven)}
            />
            I consent to the collection, use, and disclosure of my personal information as
            described above.
          </label>
        </div>
        <Button type="primary" htmlType="submit" className="submit-btn">
          Submit Consent
        </Button>
      </form>

      <Modal
        title="Consent Submitted"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        okText="Continue"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <p>Thank you! Your consent has been recorded. You can now download your report.</p>
      </Modal>
    </div>
  );
};

export default ConsentForm;
